import { makeVar } from "@apollo/client";

export const partnerTypeIdVar = makeVar(null);
export const synchronizationInProgressVar = makeVar(null);
